import { render } from "./Challenge.vue?vue&type=template&id=5e580749&scoped=true&ts=true"
import script from "./Challenge.vue?vue&type=script&lang=tsx"
export * from "./Challenge.vue?vue&type=script&lang=tsx"

import "./Challenge.vue?vue&type=style&index=0&id=5e580749&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e580749"]])

export default __exports__